import mock from "@/@fake-db/mock";
import { paginateArray, sortCompare } from "@/@fake-db/utils";

/* eslint-disable global-require */
const data = {
  vales: [
    {
      id: 4987,
      caDate: "13 Dec 2019",
      client: {
        address: "7777 Mendez Plains",
        tenantName: "Hall-Robbins PLC",
        companyEmail: "don85@johnson.com",
        country: "USA",
        contact: "(616) 865-4180",
        employeeName: "Jordan Stevenson",
      },
      service: "Software Development",
      caAmount: 3428,
      avatar: "",
      status: "Paid",
      caBalance: "$724",
      dueDate: "23 Apr 2019",
    },
    {
      id: 4988,
      caDate: "17 Jul 2019",
      client: {
        address: "04033 Wesley Wall Apt. 961",
        tenantName: "Mccann LLC and Sons",
        companyEmail: "brenda49@taylor.info",
        country: "Haiti",
        contact: "(226) 204-8287",
        employeeName: "Stephanie Burns",
      },
      service: "UI/UX Design & Development",
      caAmount: 5219,
      avatar: require("@/assets/images/avatars/10-small.png"),
      status: "Downloaded",
      caBalance: 0,
      dueDate: "15 Dec 2019",
    },
    {
      id: 4989,
      caDate: "19 Oct 2019",
      client: {
        address: "5345 Robert Squares",
        tenantName: "Leonard-Garcia and Sons",
        companyEmail: "smithtiffany@powers.com",
        country: "Denmark",
        contact: "(955) 676-1076",
        employeeName: "Tony Herrera",
      },
      service: "Unlimited Extended License",
      caAmount: 3719,
      avatar: require("@/assets/images/avatars/1-small.png"),
      status: "Paid",
      caBalance: 0,
      dueDate: "03 Nov 2019",
    },
    {
      id: 4990,
      caDate: "06 Mar 2020",
      client: {
        address: "19022 Clark Parks Suite 149",
        tenantName: "Smith, Miller and Henry LLC",
        companyEmail: "mejiageorge@lee-perez.com",
        country: "Cambodia",
        contact: "(832) 323-6914",
        employeeName: "Kevin Patton",
      },
      service: "Software Development",
      caAmount: 4749,
      avatar: require("@/assets/images/avatars/9-small.png"),
      status: "Sent",
      caBalance: 0,
      dueDate: "11 Feb 2020",
    },
    {
      id: 4991,
      caDate: "08 Feb 2020",
      client: {
        address: "8534 Saunders Hill Apt. 583",
        tenantName: "Garcia-Cameron and Sons",
        companyEmail: "brandon07@pierce.com",
        country: "Martinique",
        contact: "(970) 982-3353",
        employeeName: "Mrs. Julie Donovan MD",
      },
      service: "UI/UX Design & Development",
      caAmount: 4056,
      avatar: require("@/assets/images/avatars/10-small.png"),
      status: "Draft",
      caBalance: "$815",
      dueDate: "30 Jun 2019",
    },
    {
      id: 4992,
      caDate: "26 Aug 2019",
      client: {
        address: "661 Perez Run Apt. 778",
        tenantName: "Burnett-Young PLC",
        companyEmail: "guerrerobrandy@beasley-harper.com",
        country: "Botswana",
        contact: "(511) 938-9617",
        employeeName: "Amanda Phillips",
      },
      service: "UI/UX Design & Development",
      caAmount: 2771,
      avatar: "",
      status: "Paid",
      caBalance: 0,
      dueDate: "24 Jun 2019",
    },
    {
      id: 4993,
      caDate: "17 Sep 2019",
      client: {
        address: "074 Long Union",
        tenantName: "Wilson-Lee LLC",
        companyEmail: "williamshenry@moon-smith.com",
        country: "Montserrat",
        contact: "(504) 859-2893",
        employeeName: "Christina Collier",
      },
      service: "UI/UX Design & Development",
      caAmount: 2713,
      avatar: "",
      status: "Draft",
      caBalance: "$407",
      dueDate: "22 Nov 2019",
    },
    {
      id: 4994,
      caDate: "11 Feb 2020",
      client: {
        address: "5225 Ford Cape Apt. 840",
        tenantName: "Schwartz, Henry and Rhodes Group",
        companyEmail: "margaretharvey@russell-murray.com",
        country: "Oman",
        contact: "(758) 403-7718",
        employeeName: "David Flores",
      },
      service: "Template Customization",
      caAmount: 4309,
      avatar: require("@/assets/images/avatars/9-small.png"),
      status: "Paid",
      caBalance: "-$205",
      dueDate: "10 Feb 2020",
    },
    {
      id: 4995,
      caDate: "26 Jan 2020",
      client: {
        address: "23717 James Club Suite 277",
        tenantName: "Henderson-Holder PLC",
        companyEmail: "dianarodriguez@villegas.com",
        country: "Cambodia",
        contact: "(292) 873-8254",
        employeeName: "Valerie Perez",
      },
      service: "Software Development",
      caAmount: 3367,
      avatar: require("@/assets/images/avatars/2-small.png"),
      status: "Downloaded",
      caBalance: 0,
      dueDate: "24 Dec 2019",
    },
    {
      id: 4996,
      caDate: "15 Jan 2020",
      client: {
        address: "4528 Myers Gateway",
        tenantName: "Page-Wise PLC",
        companyEmail: "bwilson@norris-brock.com",
        country: "Guam",
        contact: "(956) 803-2008",
        employeeName: "Susan Dickerson",
      },
      service: "Software Development",
      caAmount: 4776,
      avatar: require("@/assets/images/avatars/9-small.png"),
      status: "Downloaded",
      caBalance: "$305",
      dueDate: "02 Jun 2019",
    },
    {
      id: 4997,
      caDate: "27 Sep 2019",
      client: {
        address: "4234 Mills Club Suite 107",
        tenantName: "Turner PLC Inc",
        companyEmail: "markcampbell@bell.info",
        country: "United States Virgin Islands",
        contact: "(716) 962-8635",
        employeeName: "Kelly Smith",
      },
      service: "Unlimited Extended License",
      caAmount: 3789,
      avatar: require("@/assets/images/avatars/4-small.png"),
      status: "Partial Payment",
      caBalance: "$666",
      dueDate: "18 Mar 2020",
    },
    {
      id: 4998,
      caDate: "31 Jul 2019",
      client: {
        address: "476 Keith Meadow",
        tenantName: "Levine-Dorsey PLC",
        companyEmail: "mary61@rosario.com",
        country: "Syrian Arab Republic",
        contact: "(523) 449-0782",
        employeeName: "Jamie Jones",
      },
      service: "Unlimited Extended License",
      caAmount: 5200,
      avatar: require("@/assets/images/avatars/5-small.png"),
      status: "Partial Payment",
      caBalance: 0,
      dueDate: "17 Jan 2020",
    },
    {
      id: 4999,
      caDate: "14 Feb 2020",
      client: {
        address: "56381 Ashley Village Apt. 332",
        tenantName: "Hall, Thompson and Ramirez LLC",
        companyEmail: "sean22@cook.com",
        country: "Ukraine",
        contact: "(583) 470-8356",
        employeeName: "Ruben Garcia",
      },
      service: "Software Development",
      caAmount: 4558,
      avatar: require("@/assets/images/avatars/7-small.png"),
      status: "Paid",
      caBalance: 0,
      dueDate: "01 Oct 2019",
    },
    {
      id: 5000,
      caDate: "21 May 2019",
      client: {
        address: "6946 Gregory Plaza Apt. 310",
        tenantName: "Lambert-Thomas Group",
        companyEmail: "mccoymatthew@lopez-jenkins.net",
        country: "Vanuatu",
        contact: "(366) 906-6467",
        employeeName: "Ryan Meyer",
      },
      service: "Template Customization",
      caAmount: 3503,
      avatar: require("@/assets/images/avatars/9-small.png"),
      status: "Paid",
      caBalance: 0,
      dueDate: "22 May 2019",
    },
    {
      id: 5001,
      caDate: "30 Jun 2019",
      client: {
        address: "64351 Andrew Lights",
        tenantName: "Gregory-Haynes PLC",
        companyEmail: "novakshannon@mccarty-murillo.com",
        country: "Romania",
        contact: "(320) 616-3915",
        employeeName: "Valerie Valdez",
      },
      service: "Unlimited Extended License",
      caAmount: 5285,
      avatar: require("@/assets/images/avatars/2-small.png"),
      status: "Partial Payment",
      caBalance: "-$202",
      dueDate: "02 Aug 2019",
    },
    {
      id: 5002,
      caDate: "21 Jun 2019",
      client: {
        address: "5702 Sarah Heights",
        tenantName: "Wright-Schmidt LLC",
        companyEmail: "smithrachel@davis-rose.net",
        country: "Costa Rica",
        contact: "(435) 899-1963",
        employeeName: "Melissa Wheeler",
      },
      service: "UI/UX Design & Development",
      caAmount: 3668,
      avatar: require("@/assets/images/avatars/6-small.png"),
      status: "Downloaded",
      caBalance: "$731",
      dueDate: "15 Dec 2019",
    },
    {
      id: 5003,
      caDate: "30 Dec 2019",
      client: {
        address: "668 Robert Flats",
        tenantName: "Russell-Abbott Ltd",
        companyEmail: "scott96@mejia.net",
        country: "Congo",
        contact: "(254) 399-4728",
        employeeName: "Alan Jimenez",
      },
      service: "Unlimited Extended License",
      caAmount: 4372,
      avatar: "",
      status: "Sent",
      caBalance: "-$344",
      dueDate: "17 Sep 2019",
    },
    {
      id: 5004,
      caDate: "27 May 2019",
      client: {
        address: "55642 Chang Extensions Suite 373",
        tenantName: "Williams LLC Inc",
        companyEmail: "cramirez@ross-bass.biz",
        country: "Saint Pierre and Miquelon",
        contact: "(648) 500-4338",
        employeeName: "Jennifer Morris",
      },
      service: "Template Customization",
      caAmount: 3198,
      avatar: require("@/assets/images/avatars/7-small.png"),
      status: "Partial Payment",
      caBalance: "-$253",
      dueDate: "16 Aug 2019",
    },
    {
      id: 5005,
      caDate: "30 Jul 2019",
      client: {
        address: "56694 Eric Orchard",
        tenantName: "Hudson, Bell and Phillips PLC",
        companyEmail: "arielberg@wolfe-smith.com",
        country: "Uruguay",
        contact: "(896) 544-3796",
        employeeName: "Timothy Stevenson",
      },
      service: "Unlimited Extended License",
      caAmount: 5293,
      avatar: "",
      status: "Past Due",
      caBalance: 0,
      dueDate: "01 Aug 2019",
    },
    {
      id: 5006,
      caDate: "10 Jun 2019",
      client: {
        address: "3727 Emma Island Suite 879",
        tenantName: "Berry, Gonzalez and Heath Inc",
        companyEmail: "yrobinson@nichols.com",
        country: "Israel",
        contact: "(236) 784-5142",
        employeeName: "Erik Hayden",
      },
      service: "Template Customization",
      caAmount: 5612,
      avatar: require("@/assets/images/avatars/6-small.png"),
      status: "Downloaded",
      caBalance: "$883",
      dueDate: "12 Apr 2019",
    },
    {
      id: 5007,
      caDate: "01 Feb 2020",
      client: {
        address: "953 Miller Common Suite 580",
        tenantName: "Martinez, Fuller and Chavez and Sons",
        companyEmail: "tatejennifer@allen.net",
        country: "Cook Islands",
        contact: "(436) 717-2419",
        employeeName: "Katherine Kennedy",
      },
      service: "Software Development",
      caAmount: 2230,
      avatar: require("@/assets/images/avatars/1-small.png"),
      status: "Sent",
      caBalance: 0,
      dueDate: "19 Nov 2019",
    },
    {
      id: 5008,
      caDate: "22 Mar 2020",
      client: {
        address: "808 Sullivan Street Apt. 135",
        tenantName: "Wilson and Sons LLC",
        companyEmail: "gdurham@lee.com",
        country: "Nepal",
        contact: "(489) 946-3041",
        employeeName: "Monica Fuller",
      },
      service: "Unlimited Extended License",
      caAmount: 2032,
      avatar: require("@/assets/images/avatars/8-small.png"),
      status: "Partial Payment",
      caBalance: 0,
      dueDate: "30 Nov 2019",
    },
    {
      id: 5009,
      caDate: "30 Nov 2019",
      client: {
        address: "25135 Christopher Creek",
        tenantName: "Hawkins, Johnston and Mcguire PLC",
        companyEmail: "jenny96@lawrence-thompson.com",
        country: "Kiribati",
        contact: "(274) 246-3725",
        employeeName: "Stacey Carter",
      },
      service: "UI/UX Design & Development",
      caAmount: 3128,
      avatar: require("@/assets/images/avatars/3-small.png"),
      status: "Paid",
      caBalance: 0,
      dueDate: "10 Sep 2019",
    },
    {
      id: 5010,
      caDate: "06 Jan 2020",
      client: {
        address: "81285 Rebecca Estates Suite 046",
        tenantName: "Huynh-Mills and Sons",
        companyEmail: "jgutierrez@jackson.com",
        country: "Swaziland",
        contact: "(258) 211-5970",
        employeeName: "Chad Davis",
      },
      service: "Software Development",
      caAmount: 2060,
      avatar: require("@/assets/images/avatars/2-small.png"),
      status: "Downloaded",
      caBalance: 0,
      dueDate: "08 Dec 2019",
    },
    {
      id: 5011,
      caDate: "01 Jun 2019",
      client: {
        address: "3102 Briggs Dale Suite 118",
        tenantName: "Jones-Cooley and Sons",
        companyEmail: "hunter14@jones.com",
        country: "Congo",
        contact: "(593) 965-4100",
        employeeName: "Chris Reyes",
      },
      service: "UI/UX Design & Development",
      caAmount: 4077,
      avatar: "",
      status: "Draft",
      caBalance: 0,
      dueDate: "01 Feb 2020",
    },
    {
      id: 5012,
      caDate: "30 Oct 2019",
      client: {
        address: "811 Jill Skyway",
        tenantName: "Jones PLC Ltd",
        companyEmail: "pricetodd@johnson-jenkins.com",
        country: "Brazil",
        contact: "(585) 829-2603",
        employeeName: "Laurie Summers",
      },
      service: "Template Customization",
      caAmount: 2872,
      avatar: require("@/assets/images/avatars/4-small.png"),
      status: "Partial Payment",
      caBalance: 0,
      dueDate: "18 Oct 2019",
    },
    {
      id: 5013,
      caDate: "05 Feb 2020",
      client: {
        address: "2223 Brandon Inlet Suite 597",
        tenantName: "Jordan, Gomez and Ross Group",
        companyEmail: "perrydavid@chapman-rogers.com",
        country: "Congo",
        contact: "(527) 351-5517",
        employeeName: "Lindsay Wilson",
      },
      service: "Software Development",
      caAmount: 3740,
      avatar: require("@/assets/images/avatars/10-small.png"),
      status: "Draft",
      caBalance: 0,
      dueDate: "01 Nov 2019",
    },
    {
      id: 5014,
      caDate: "01 Dec 2019",
      client: {
        address: "08724 Barry Causeway",
        tenantName: "Gonzalez, Moody and Glover LLC",
        companyEmail: "leahgriffin@carpenter.com",
        country: "Equatorial Guinea",
        contact: "(628) 903-0132",
        employeeName: "Jenna Castro",
      },
      service: "Unlimited Extended License",
      caAmount: 3623,
      avatar: "",
      status: "Downloaded",
      caBalance: 0,
      dueDate: "23 Sep 2019",
    },
    {
      id: 5015,
      caDate: "16 Apr 2019",
      client: {
        address: "073 Holt Ramp Apt. 755",
        tenantName: "Ashley-Pacheco Ltd",
        companyEmail: "esparzadaniel@allen.com",
        country: "Seychelles",
        contact: "(847) 396-9904",
        employeeName: "Wendy Weber",
      },
      service: "Software Development",
      caAmount: 2477,
      avatar: require("@/assets/images/avatars/7-small.png"),
      status: "Draft",
      caBalance: 0,
      dueDate: "01 Apr 2019",
    },
    {
      id: 5016,
      caDate: "24 Jan 2020",
      client: {
        address: "984 Sherry Trail Apt. 953",
        tenantName: "Berry PLC Group",
        companyEmail: "todd34@owens-morgan.com",
        country: "Ireland",
        contact: "(852) 249-4539",
        employeeName: "April Yates",
      },
      service: "Unlimited Extended License",
      caAmount: 3904,
      avatar: "",
      status: "Paid",
      caBalance: "$951",
      dueDate: "30 Sep 2019",
    },
    {
      id: 5017,
      caDate: "24 Feb 2020",
      client: {
        address: "093 Jonathan Camp Suite 953",
        tenantName: "Allen Group Ltd",
        companyEmail: "roydavid@bailey.com",
        country: "Netherlands",
        contact: "(917) 984-2232",
        employeeName: "Daniel Marshall PhD",
      },
      service: "UI/UX Design & Development",
      caAmount: 3102,
      avatar: require("@/assets/images/avatars/1-small.png"),
      status: "Partial Payment",
      caBalance: "-$153",
      dueDate: "25 Aug 2019",
    },
    {
      id: 5018,
      caDate: "29 Feb 2020",
      client: {
        address: "4735 Kristie Islands Apt. 259",
        tenantName: "Chapman-Schneider LLC",
        companyEmail: "baldwinjoel@washington.com",
        country: "Cocos (Keeling) Islands",
        contact: "(670) 409-3703",
        employeeName: "Randy Rich",
      },
      service: "UI/UX Design & Development",
      caAmount: 2483,
      avatar: require("@/assets/images/avatars/5-small.png"),
      status: "Draft",
      caBalance: 0,
      dueDate: "10 Jul 2019",
    },
    {
      id: 5019,
      caDate: "07 Aug 2019",
      client: {
        address: "92218 Andrew Radial",
        tenantName: "Mcclure, Hernandez and Simon Ltd",
        companyEmail: "psmith@morris.info",
        country: "Macao",
        contact: "(646) 263-0257",
        employeeName: "Mrs. Jodi Chapman",
      },
      service: "Unlimited Extended License",
      caAmount: 2825,
      avatar: require("@/assets/images/avatars/8-small.png"),
      status: "Partial Payment",
      caBalance: "-$459",
      dueDate: "14 Oct 2019",
    },
    {
      id: 5020,
      caDate: "10 May 2019",
      client: {
        address: "2342 Michelle Valley",
        tenantName: "Hamilton PLC and Sons",
        companyEmail: "lori06@morse.com",
        country: "Somalia",
        contact: "(751) 213-4288",
        employeeName: "Steven Myers",
      },
      service: "Unlimited Extended License",
      caAmount: 2029,
      avatar: require("@/assets/images/avatars/4-small.png"),
      status: "Past Due",
      caBalance: 0,
      dueDate: "28 Mar 2019",
    },
    {
      id: 5021,
      caDate: "02 Apr 2019",
      client: {
        address: "16039 Brittany Terrace Apt. 128",
        tenantName: "Silva-Reeves LLC",
        companyEmail: "zpearson@miller.com",
        country: "Slovakia (Slovak Republic)",
        contact: "(655) 649-7872",
        employeeName: "Charles Alexander",
      },
      service: "Software Development",
      caAmount: 3208,
      avatar: "",
      status: "Sent",
      caBalance: 0,
      dueDate: "06 Sep 2019",
    },
    {
      id: 5022,
      caDate: "02 May 2019",
      client: {
        address: "37856 Olsen Lakes Apt. 852",
        tenantName: "Solis LLC Ltd",
        companyEmail: "strongpenny@young.net",
        country: "Brazil",
        contact: "(402) 935-0735",
        employeeName: "Elizabeth Jones",
      },
      service: "Software Development",
      caAmount: 3077,
      avatar: "",
      status: "Sent",
      caBalance: 0,
      dueDate: "09 May 2019",
    },
    {
      id: 5023,
      caDate: "23 Mar 2020",
      client: {
        address: "11489 Griffin Plaza Apt. 927",
        tenantName: "Munoz-Peters and Sons",
        companyEmail: "carrietorres@acosta.com",
        country: "Argentina",
        contact: "(915) 448-6271",
        employeeName: "Heidi Walton",
      },
      service: "Software Development",
      caAmount: 5578,
      avatar: require("@/assets/images/avatars/9-small.png"),
      status: "Draft",
      caBalance: 0,
      dueDate: "23 Jul 2019",
    },
    {
      id: 5024,
      caDate: "28 Sep 2019",
      client: {
        address: "276 Michael Gardens Apt. 004",
        tenantName: "Shea, Velez and Garcia LLC",
        companyEmail: "zjohnson@nichols-powers.com",
        country: "Philippines",
        contact: "(817) 700-2984",
        employeeName: "Christopher Allen",
      },
      service: "Software Development",
      caAmount: 2787,
      avatar: require("@/assets/images/avatars/1-small.png"),
      status: "Partial Payment",
      caBalance: 0,
      dueDate: "25 Sep 2019",
    },
    {
      id: 5025,
      caDate: "21 Feb 2020",
      client: {
        address: "633 Bell Well Apt. 057",
        tenantName: "Adams, Simmons and Brown Group",
        companyEmail: "kayla09@thomas.com",
        country: "Martinique",
        contact: "(266) 611-9482",
        employeeName: "Joseph Oliver",
      },
      service: "UI/UX Design & Development",
      caAmount: 5591,
      avatar: "",
      status: "Downloaded",
      caBalance: 0,
      dueDate: "07 Jun 2019",
    },
    {
      id: 5026,
      caDate: "24 May 2019",
      client: {
        address: "1068 Lopez Fall",
        tenantName: "Williams-Lawrence and Sons",
        companyEmail: "melvindavis@allen.info",
        country: "Mexico",
        contact: "(739) 745-9728",
        employeeName: "Megan Roberts",
      },
      service: "Template Customization",
      caAmount: 2783,
      avatar: require("@/assets/images/avatars/6-small.png"),
      status: "Draft",
      caBalance: 0,
      dueDate: "22 Oct 2019",
    },
    {
      id: 5027,
      caDate: "13 Jan 2020",
      client: {
        address: "86691 Mackenzie Light Suite 568",
        tenantName: "Deleon Inc LLC",
        companyEmail: "gjordan@fernandez-coleman.com",
        country: "Costa Rica",
        contact: "(682) 804-6506",
        employeeName: "Mary Garcia",
      },
      service: "Template Customization",
      caAmount: 2719,
      avatar: "",
      status: "Sent",
      caBalance: 0,
      dueDate: "04 Feb 2020",
    },
    {
      id: 5028,
      caDate: "18 May 2019",
      client: {
        address: "86580 Sarah Bridge",
        tenantName: "Farmer, Johnson and Anderson Group",
        companyEmail: "robertscott@garcia.com",
        country: "Cameroon",
        contact: "(775) 366-0411",
        employeeName: "Crystal Mays",
      },
      service: "Template Customization",
      caAmount: 3325,
      avatar: "",
      status: "Paid",
      caBalance: "$361",
      dueDate: "02 Mar 2020",
    },
    {
      id: 5029,
      caDate: "29 Oct 2019",
      client: {
        address: "49709 Edwin Ports Apt. 353",
        tenantName: "Sherman-Johnson PLC",
        companyEmail: "desiree61@kelly.com",
        country: "Macedonia",
        contact: "(510) 536-6029",
        employeeName: "Nicholas Tanner",
      },
      service: "Template Customization",
      caAmount: 3851,
      avatar: "",
      status: "Paid",
      caBalance: 0,
      dueDate: "25 Aug 2019",
    },
    {
      id: 5030,
      caDate: "07 Apr 2019",
      client: {
        address: "3856 Mathis Squares Apt. 584",
        tenantName: "Byrd LLC PLC",
        companyEmail: "jeffrey25@martinez-hodge.com",
        country: "Congo",
        contact: "(253) 230-4657",
        employeeName: "Mr. Justin Richardson",
      },
      service: "Template Customization",
      caAmount: 5565,
      avatar: "",
      status: "Draft",
      caBalance: 0,
      dueDate: "06 Mar 2020",
    },
    {
      id: 5031,
      caDate: "21 Aug 2019",
      client: {
        address: "141 Adrian Ridge Suite 550",
        tenantName: "Stone-Zimmerman Group",
        companyEmail: "john77@anderson.net",
        country: "Falkland Islands (Malvinas)",
        contact: "(612) 546-3485",
        employeeName: "Jennifer Summers",
      },
      service: "Template Customization",
      caAmount: 3313,
      avatar: require("@/assets/images/avatars/3-small.png"),
      status: "Partial Payment",
      caBalance: 0,
      dueDate: "09 Jun 2019",
    },
    {
      id: 5032,
      caDate: "31 May 2019",
      client: {
        address: "01871 Kristy Square",
        tenantName: "Yang, Hansen and Hart PLC",
        companyEmail: "ywagner@jones.com",
        country: "Germany",
        contact: "(203) 601-8603",
        employeeName: "Richard Payne",
      },
      service: "Template Customization",
      caAmount: 5181,
      avatar: "",
      status: "Past Due",
      caBalance: 0,
      dueDate: "22 Oct 2019",
    },
    {
      id: 5033,
      caDate: "12 Jul 2019",
      client: {
        address: "075 Smith Views",
        tenantName: "Jenkins-Rosales Inc",
        companyEmail: "calvin07@joseph-edwards.org",
        country: "Colombia",
        contact: "(895) 401-4255",
        employeeName: "Lori Wells",
      },
      service: "Template Customization",
      caAmount: 2869,
      avatar: require("@/assets/images/avatars/1-small.png"),
      status: "Partial Payment",
      caBalance: 0,
      dueDate: "22 Mar 2020",
    },
    {
      id: 5034,
      caDate: "10 Jul 2019",
      client: {
        address: "2577 Pearson Overpass Apt. 314",
        tenantName: "Mason-Reed PLC",
        companyEmail: "eric47@george-castillo.com",
        country: "Paraguay",
        contact: "(602) 336-9806",
        employeeName: "Tammy Sanchez",
      },
      service: "Unlimited Extended License",
      caAmount: 4836,
      avatar: "",
      status: "Paid",
      caBalance: 0,
      dueDate: "22 Oct 2019",
    },
    {
      id: 5035,
      caDate: "20 Jul 2019",
      client: {
        address: "1770 Sandra Mountains Suite 636",
        tenantName: "Foster-Pham PLC",
        companyEmail: "jamesjoel@chapman.net",
        country: "Western Sahara",
        contact: "(936) 550-1638",
        employeeName: "Dana Carey",
      },
      service: "UI/UX Design & Development",
      caAmount: 4263,
      avatar: "",
      status: "Draft",
      caBalance: "$762",
      dueDate: "12 Jun 2019",
    },
    {
      id: 5036,
      caDate: "19 Apr 2019",
      client: {
        address: "78083 Laura Pines",
        tenantName: "Richardson and Sons LLC",
        companyEmail: "jojoyu@yahoo.com",
        country: "Bhutan",
        contact: "(687) 660-2473",
        employeeName: "Jojo Yu",
      },
      service: "Unlimited Extended License",
      caAmount: 3171,
      avatar: require("@/assets/images/avatars/14-small.png"),
      status: "Paid",
      caBalance: "-$205",
      dueDate: "25 Sep 2019",
    },
  ],
};
/* eslint-enable */

// ------------------------------------------------
// GET: Return Users
// ------------------------------------------------
mock.onGet("/apps/vale/vales").reply((config) => {
  // eslint-disable-next-line object-curly-newline
  const {
    q = "",
    perPage = 10,
    page = 1,
    sortBy = "id",
    sortDesc = false,
    status = null,
  } = config.params;
  /* eslint-enable */

  const queryLowered = q.toLowerCase();
  const filteredData = data.vales.filter(
    (vale) =>
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      (vale.client.companyEmail.toLowerCase().includes(queryLowered) ||
        vale.client.name.toLowerCase().includes(queryLowered)) &&
      vale.status === (status || vale.status)
  );
  /* eslint-enable  */

  const sortedData = filteredData.sort(sortCompare(sortBy));
  if (sortDesc) sortedData.reverse();

  return [
    200,
    {
      vales: paginateArray(sortedData, perPage, page),
      total: filteredData.length,
    },
  ];
});

// ------------------------------------------------
// GET: Return Single Invoice
// ------------------------------------------------
mock.onGet(/\/apps\/vale\/vales\/\d+/).reply((config) => {
  // Get event id from URL
  let valeId = config.url.substring(config.url.lastIndexOf("/") + 1);

  // Convert Id to number
  valeId = Number(valeId);

  const valeIndex = data.vales.findIndex((e) => e.id === valeId);
  const vale = data.vales[valeIndex];
  const responseData = {
    vale,
    paymentDetails: {
      totalDue: "$12,110.55",
      bankName: "American Bank",
      country: "United States",
      iban: "ETD95476213874685",
      swiftCode: "BR91905",
    },
  };

  if (vale) return [200, responseData];
  return [404];
});

// ------------------------------------------------
// GET: Return Clients
// ------------------------------------------------
mock.onGet("/apps/vale/clients").reply(() => {
  const clients = data.vales.map((vale) => vale.client);
  return [200, clients];
});
